module.exports = __webpack_public_path__ + "static/img/head-total-money.49370fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/head-total-money.png
// module id = xzBI
// module chunks = 1